const React = require("react");
const { SessionProvider } = require("./src/context/SessionContext");
const { VWOProvider } = require("./src/context/VWOContext"); // your wrapper
const { getStableFmeId } = require("./src/utils/fmeIdentity");

// Configure FontAwesome to prevent flash of oversized icons
const { config } = require('@fortawesome/fontawesome-svg-core');
config.autoAddCss = false; // Tell Font Awesome to skip adding the CSS automatically

require('@fortawesome/fontawesome-svg-core/styles.css'); // Import the CSS manually

// Ensure FME ID exists before any components mount to prevent MTU inflation
exports.onClientEntry = () => {
  // Create stable FME ID early to ensure it's available for all components
  getStableFmeId();
};

// Mount long-lived providers without VWO (VWO is page-specific)
exports.wrapRootElement = ({ element }) => {
  return (
    <SessionProvider>
      {element}
    </SessionProvider>
  );
};

// Add VWO per-page with access to pageContext
exports.wrapPageElement = ({ element, props }) => {
  return (
    <VWOProvider pageContext={props.pageContext}>
      {element}
    </VWOProvider>
  );
};
